export default class ErrorsTerms{
    InternalErroTitle: string = "������";
    InternalErrorText: string = "�������������� ������";
    SystemErrorTitle: string = "������";
    SystemErrorText: string = "��������� ������";
    AccessDeniedTitle: string = "������ ��������";
    AccessDeniedText: string = "������������ ���� ��� ������� � ������� �����������";
}